<template>
  <div class="node align-items-center">
    <div class="perms" data-class="pb-4 pt-4" :class="node.slug=='left-margin-tabs'?'text-primary':''">{{ node.name }}</div>
    <div class="child border-bottom" v-for="policy in node.policies">
      <div class="d-flex align-items-center">
        <div style="width: 40%;" class="p-2">{{ policy.name }}</div>
        <div style="padding-left: 100px;width: 100%;" class="d-flex justify-content-end align-items-center">
          <div class="d-flex align-items-center">
            <div v-for="subgroup in policy.subgroups" class="form-check form-check-solid form-switch form-switch-sm"
                 style="width: 155px !important;">
              <input v-model="subgroup.subgroup_set"
                     @change="onChange(node.id, policy.id, subgroup.id, $event)" class="form-check-input"
                     type="checkbox">
            </div>
          </div>
        </div>
      </div>
    </div>
    <tree-node v-if="node.children" v-for="child in node.children" :onchange="onChange" :node="child" :key="child.id"/>
  </div>
</template>

<script>
export default {
  props: ['node', 'onchange'],
  methods: {
    onChange(permission, policy, subgroup, e){
      if (this.onchange){
        this.onchange(permission, policy, subgroup, e);
      }
    }
  }
};
</script>

<style scoped>
.node {
  padding-left: 20px;
}

.perms {
  font-weight: bold;
  font-size: 16px;

}

.child {
  padding-left: 20px;
}
</style>